// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4e26096a","553":"c61524e8"}[chunkId] + ".chunk.js";
};